import axios from 'axios'
import { call } from 'file-loader'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}


//user manajemen

function getGeneralAds(callback) {
    var config = getConfig()
  
    http.get('/promotion/config-ads', config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getInternalAds(callback) {
    var config = getConfig()
  
    http.get('/promotion/internal-ads', config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function saveGeneralAdsSetting (dataBody, callback)
  {
    var config = getConfig()

    http.put('/promotion/config-ads', dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function saveInternalAdsSetting (dataBody, callback)
  {
    var config = getConfig()

    http.post('/promotion/internal-ads', dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function updateInternalAdsSetting (dataBody, callback)
  {
    var config = getConfig()

    http.put('/promotion/internal-ads/' + dataBody.id, dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function deleteInternalAds (dataBody, callback)
  {
    var config = getConfig()

    http.delete('/promotion/internal-ads/' + dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }
  

export default
{
    getGeneralAds,
    getInternalAds,
    saveGeneralAdsSetting,
    deleteInternalAds,
    saveInternalAdsSetting,
    updateInternalAdsSetting
}



// WEBPACK FOOTER //
// ./src/services/ads.js